import axios from "axios";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_URL, // url = base url + request url
  // timeout: 5000 // request timeout
});

// request interceptor do something before request is sent
service.interceptors.request.use(
  (config) => {
    var userData = JSON.parse(localStorage.getItem("userData"));
    config.headers = {
      "content-type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer " + userData.token,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response.status == 401) {
      localStorage.clear();
      alert("Your session is expired.Please login again");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default service;
